import EventHandler from '../../events/event_handler';
import ImportedSearcherEvents from './searcher_events';

export const SearcherEvents = ImportedSearcherEvents;
export const SearcherEventHandler = new EventHandler(Object.values(SearcherEvents));

export default SearcherEventHandler;
